export default "__VITE_ASSET__3f9393f7__"